import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';
import classnames from 'classnames';
import combineStyles from '../../../helpers/combineStyles';
import LayoutStyles from '../../../styles/layout';
import ButtonStyles from '../../../styles/button';
import TypographyStyles from '../../../styles/typography';
import SpacingStyles from '../../../styles/helpers/spacing';
import ListsStyle from '../__styles__/Lists.style';
import Table from '../../shared/Table/Table';
import { columns, mapData } from './TableMetaData';
import { DEFAULT_ROWS_PER_PAGE } from '../../../constants/request_constants';
import parseQuerystring from '../../../helpers/parseQuerystring';
import RolesFilter from './RolesFilter';
import Button from '@material-ui/core/Button';

class RolesPage extends Component {
  state = {
    rowsPerPage:
      Number(sessionStorage.getItem('BrillaRowsPerPage')) ||
      DEFAULT_ROWS_PER_PAGE
  };

  componentDidMount() {
    this._fetchItems();
    this.props.fetchPermissionsNames();
  }

  _fetchItems = params => {
    const query = params || parseQuerystring(this.props) || {};
    this.props.fetchRoles({
      ...query,
      page: query.page || 1,
      perPage: this.state.rowsPerPage
    });
  };

  _handleChangePage = page => {
    const query = parseQuerystring(this.props) || {};
    this._fetchItems({
      ...query,
      page: page + 1
    });
  };

  _handleChangeRowsPerPage = rowsPerPage => {
    sessionStorage.setItem('BrillaRowsPerPage', rowsPerPage);
    this.setState({ rowsPerPage: rowsPerPage, page: 1 }, this._fetchItems);
  };

  _handleOpenCreateRole = () => {
    this.props.history.push(`/roles/new`);
  };

  _handleRowClick = (item, canEditRolesAdmin) => {
    if (canEditRolesAdmin) {
      this.props.history.push(`/roles/edit/${item.id}`);
    }
  };

  render() {
    const {
      classes,
      roles,
      meta,
      requestRolesSend = true,
      canCreateRolesAdmin,
      canEditRolesAdmin
    } = this.props;
    const { page } = parseQuerystring(this.props) || {};

    return (
      <div>
        <div className={classes.titleRootWrapper}>
          <h1 className={classnames(classes.headline4, classes.title)}>
            {'Roles'}
          </h1>
          {canCreateRolesAdmin && (
            <Button
              className={classes.button}
              classes={{
                label: classes.buttonLabel
              }}
              variant="contained"
              color="secondary"
              onClick={this._handleOpenCreateRole}
            >
              {'Crear Rol'}
            </Button>
          )}
        </div>
        <div>
          <div className={classes.filterOptionsWrapper}>
            <RolesFilter onChangeFilter={this._fetchItems} />
          </div>
        </div>
        <div>
          <Table
            name={'Roles'}
            columns={columns}
            data={mapData(roles)}
            onChangePage={this._handleChangePage}
            onChangePageRowsPerPage={this._handleChangeRowsPerPage}
            page={page - 1}
            rowsPerPage={this.state.rowsPerPage}
            totalCount={roles.length}
            nextPage={meta.nextPage}
            withNoCountPagination={true}
            onClickOnRow={props => {
              this._handleRowClick(props, canEditRolesAdmin);
            }}
            loading={requestRolesSend}
          />
        </div>
      </div>
    );
  }
}

const styles = (/* theme */) => ({});

export default withStyles(
  combineStyles(
    styles,
    LayoutStyles,
    ButtonStyles,
    TypographyStyles,
    SpacingStyles,
    ListsStyle,
    { withTheme: true }
  )
)(RolesPage);
